/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module GslbModule */

import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';

import { L10nService } from '@vmw/ngx-vip';
import { debounce } from 'underscore';
import { GslbPoolMember } from 'object-types';
import { GslbPoolMemberConfigItem } from 'message-items/gslb-pool-member.config-item.factory';
import * as l10n from './gslb-pool-member-domain-name.l10n';
import './gslb-pool-member-domain-name.component.less';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description
 *      GSLB pool member domain name component. It is used for IP address configured pool members.
 * @author Suraj Kumar, Umesh Chovatiya, alextsg
 */
@Component({
    selector: 'gslb-pool-member-domain-name',
    templateUrl: './gslb-pool-member-domain-name.component.html',
})
export class GslbPoolMemberDomainNameComponent implements OnInit {
    @Input()
    public editable: GslbPoolMemberConfigItem;

    /**
     * Reference for GSLB Service Type is SRV or not.
     */
    @Input()
    public isGSLBServiceRecordTypeSRV = false;

    /**
     * Emit on FQDN or IP address value change.
     */
    @Output()
    private onIpOrFqdnChange = new EventEmitter<void>();

    /**
     * ngModel value for the IP(v4/v6) or FQDN input.
     */
    public ipOrFqdnInputValue: string;

    public readonly objectType = GslbPoolMember;

    public readonly l10nKeys = l10nKeys;

    constructor(l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);

        this.handleIpOrFqdnChange = debounce(this.handleIpOrFqdnChange, 500);
    }

    /** @override */
    public ngOnInit(): void {
        this.ipOrFqdnInputValue = this.editable.memberAddress;
    }

    /**
     * Handle FQDN or IP address change.
     */
    public handleIpOrFqdnChange = (): void => {
        this.editable.handleIpOrFqdnChange(this.ipOrFqdnInputValue);
        this.onIpOrFqdnChange.emit();
    };
}
